import { useQueryClient } from '@tanstack/react-query'
import React from 'react'

import { useSurveyQueryFn } from './useSurveyQueryFn'
import { useSurveyQueryKey } from './useSurveyQueryKey'

export const useFetchSurveyQuery = () => {
  const queryFn = useSurveyQueryFn()
  const queryKey = useSurveyQueryKey()
  const queryClient = useQueryClient()

  return React.useCallback(
    async () => await queryClient.fetchQuery({ queryFn, queryKey }),
    [queryClient, queryFn, queryKey],
  )
}
